import { ErrorMessage } from 'ng-bootstrap-form-validation';

export const CUSTOM_ERRORS: ErrorMessage[] = [
  {
    error: 'required',
    format: requiredFormat
  }, {
    error: 'email',
    format: emailFormat
  }, {
    error: 'integer',
    format: integerFormat
  }, {
    error: 'decimal',
    format: decimalFormat
  }, {
    error: 'date',
    format: dateFormat
  }, {
    error: 'phone',
    format: phoneFormat
  }, {
    error: 'minYear2008',
    format: minYear2008Format
  }, {
    error: 'true',
    format: trueFormat
  }, {
    error: 'beforeToday',
    format: beforeTodayFormat
  }, {
    error: 'afterTodayPlus14',
    format: afterTodayPlus14Format
  }, {
    error: 'afterToday',
    format: afterTodayFormat
  }, {
    error: 'min22000',
    format: min22000Format
  }, {
    error: 'min50000',
    format: min50000Format
  }, {
    error: 'min18years',
    format: min18yearsFormat
  }
];

export function requiredFormat(label: string, error: any): string {
  return `Ce champ est obligatoire.`;
}

export function emailFormat(label: string, error: any): string {
  return `Adresse e-mail non valide.`;
}

export function integerFormat(label: string, error: any): string {
  return `Nombre entier non valide.`;
}

export function decimalFormat(label: string, error: any): string {
  return `Nombre décimal non valide.`;
}

export function dateFormat(label: string, error: any): string {
  return `Date non valide.`;
}

export function phoneFormat(label: string, error: any): string {
  return `Numéro de téléphone non valide.`;
}

export function minYear2008Format(label: string, error: any): string {
  return `La date doit être supérieure au 01/01/2008.`;
}

export function trueFormat(label: string, error: any): string {
  return `Vous devez reconnaître avoir été informé de l'utilisation de vos données personnelles 
    dans le cadre du remplissage de ce formulaire.`;
}

export function beforeTodayFormat(label: string, error: any): string {
  return `La date sélectionnée doit être antérieure à la date du jour.`;
}

export function afterTodayFormat(label: string, error: any): string {
  return `La date sélectionnée doit être postérieure à la date du jour.`;
}

export function afterTodayPlus14Format(label: string, error: any): string {
  return `La date de signature doit se situer dans les 15 jours minimum.`;
}

export function min22000Format(label: string, error: any): string {
  return `Le capital restant doit être d'au minimum 22000 €.`;
}

export function min50000Format(label: string, error: any): string {
  return `Le capital restant doit être d'au minimum 50000 €.`;
}

export function min18yearsFormat(label: string, error: any): string {
  return `L'âge minimum est de 18 ans.`;
}



// WEBPACK FOOTER //
// ./src/app/custom-errors.ts